import React from "react";

import { observer } from "mobx-react";
import Link from "next/link";
import styled from "styled-components";

import { useStores } from "../../../contexts/StoreContext";

const StyledAnchor = styled.a`
  color: ${({ theme }) => theme.negativeTextColor};
  font-size: 1.25rem;

  &:hover {
    color: ${({ theme }) => theme.negativeTextColor};
    text-decoration: underline !important;
  }
`;

const StyledBottomFooter = styled.div`
  color: ${({ theme }) => theme.primaryColor};

  a {
    text-decoration: none;
    color: ${({ theme }) => theme.primaryColor};
  }
`;

const StyledBarFooter = styled.div`
  background-color: ${({ theme, $backgroundColour }) =>
    `${$backgroundColour || theme.footerBackgroundColor || theme.primaryColor}`};
`;

const StyledBottomFooterWrapper = styled.div`
  background-color: ${({ theme, $backgroundColour }) =>
    `${$backgroundColour || theme.footerBackgroundColor || theme.primaryColor}`};
`;

function BarFooter(props) {
  const { navigationStore, footerStore } = useStores();

  const { footerLinks } = navigationStore;

  const { footerText } = footerStore;

  return (
    <>
      <StyledBarFooter
        className="pt-3 py-md-0"
        $backgroundColour={props?.backgroundColour}
      >
        <div className="container-xxl d-flex justify-content-center">
          <div className="row">
            {footerLinks.map((link) => {
              const href = link.path ? `/${link.path}` : link.externalPath;
              return (
                <div key={link.id} className="col-md text-nowrap">
                  <Link href={href} passHref legacyBehavior>
                    <StyledAnchor className="text-decoration-none p-md-3 text-uppercase d-block mb-3 my-md-3">
                      {link.title}
                    </StyledAnchor>
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </StyledBarFooter>

      <StyledBottomFooterWrapper
        className="container-xxl py-2"
        $backgroundColour={props?.backgroundColour}
      >
        <StyledBottomFooter className="d-flex justify-content-between align-items-center">
          <span className="me-5">{footerText}</span>
          <span className="me-5">
            Site by <a href="https://talent-funnel.com">Talent Funnel</a>
          </span>
          <Link href="/sitemap">Sitemap</Link>
        </StyledBottomFooter>
      </StyledBottomFooterWrapper>
    </>
  );
}

export default observer(BarFooter);
